module.exports = __webpack_public_path__ + "img/7.Ζάκυνθος-min.d0289612.jpg";